import React, {Component} from 'react';
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import SearchComponent from './SearchPanel';
import {connect} from "react-redux";
import withMobileDialog from "@material-ui/core/withMobileDialog/index";
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import {alertActions, commonActions} from "../../_actions";
import {store} from "../../_store";
import RouteFormPanel from './RouteFormPanel';
import RecordsTable from './RecordsTable';
import AirlineRoutes from './AirlineRoute';
import {commonService} from "../../_services";
import {appConstants} from "../../_constants";
import Dialog from "@material-ui/core/Dialog";
import DismissIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
import CheckIcon from "@material-ui/icons/Check";
import DeclineIcon from "@material-ui/icons/Close";
import {
    TextField
} from "@material-ui/core";
import Modal from "../../utils/Modal";
import AirlineRouteTable from "./ViewSelectedRoute"
import Tabs from "components/CustomTabs/CustomTabs.jsx";

const customModalStyle = {
    width: '75%',
    maxWidth: 'none',
    overflow: 'scroll'
};

class AirlineRouteComponent extends Component {
    constructor(props) {
        super(props);
        this.state ={
            AirlineId: '-1',
            Status: '-1',
            statuses:
            [
                {Id: "-1", Name: "All Statuses"},
                {Id: 0, Name: 'Pending'},
                {Id: 1, Name: 'Approved'},
                {Id: 2, Name: 'Rejected'}
            ],
            createdByStatus: "-1",
            createdByStatuses: [
                {Id: "-1", Name: 'Everyone'},
                {Id: 1, Name: 'Me'}
            ],
            pageSize: 10,
            currentPage: 1,
            totalCounts: 0,
            airlinesRoutes: [],
            routeFormModal: false,
            approvalModal: false,
            viewModal: false,
            approvalStatus: false,
            selectedAirlineRouteRecord: false,
            Comment: "",
          currentTab: 0
        }
    }

    componentDidMount(){
        let {regionalAirlines, regionalAirports, users } = store.getState();
        const { dispatch } = this.props;
        if(!regionalAirlines){
            dispatch(commonActions.getAllAirlinesRegional());
        }
        if(!regionalAirports){
            dispatch(commonActions.getAllAirportsRegional())
        }

        if(!users){
            dispatch(commonActions.getAllUsers());
        }

        this.handleSearch();
    }

    handleSelectChange = (event) =>{
        this.setState({[event.target.name] : event.target.value })
    };

    handleReactSelectChange = (value, name) => {
        this.setState({[name.name]: value.value})
    };

    handleSearch = (pageNumber = 1, payload) =>{
        const { AirlineId, Status, pageSize, createdByStatus } = this.state;
        const { dispatch, user } = this.props;

        if(!payload){
            payload = {
                From: pageNumber,
                Size: pageSize
            };
            if(AirlineId !== "-1"){
                payload.AirlineId = AirlineId;
            }
            if(Status !== "-1"){
                payload.Status = Status;
            }
            if(createdByStatus === 1){
                payload.CreatedBy = user.userId;
            }
        }
        dispatch(alertActions.startRequest());
        commonService.searchPendingAirlineRouteRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        currentPage: pageNumber,
                        totalCounts: response.TotalCount,
                        airlinesRoutes: response.PendingAirlineRoute
                    });
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                }
            });
    }

    handleApproval = () =>{
        const  { selectedAirlineRouteRecord, approvalStatus,  Comment } = this.state;
        const { user, dispatch } = this.props;
        const payload = {
            PendingAirlineRouteId: selectedAirlineRouteRecord.Id,
            ProcessedBy: user.userId,
            Status : approvalStatus,
            Comment :  Comment
        };
        dispatch(alertActions.startRequest());
        commonService.airlineRouteApprovalRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.handleSearch(1);
                    this.setState({approvalModal: false});
                    dispatch(alertActions.notify('Operation successful'));
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                }
            });
    }

    handleAddRouteModal = () =>{
       this.setState(prevState => ({routeFormModal : !prevState.routeFormModal}))
    }

    handleViewRouteModal = (selectedAirlineRouteRecord) =>{
       this.setState(prevState => ({
                viewModal : !prevState.viewModal,
               selectedAirlineRouteRecord
            }
       ))
    };

    closeViewRouteModal = () =>{
        this.setState(prevState => ({
                viewModal : !prevState.viewModal,
            }
        ))
    };

    handleApprovalModal = (approvalStatus, selectedAirlineRouteRecord) =>{
        this.setState(prevState => ({ selectedAirlineRouteRecord, approvalStatus, approvalModal : !prevState.approvalModal}))
    }

    handleDismissApprovalModal = () => {
        this.setState({approvalModal: false})
    }

    handleCreateRoute = (payload) =>{
       const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        commonService.saveAirlineRouteRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        routeFormModal: false
                    });
                    this.handleSearch(1);
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                }
            });
    }

    filterUsers = (userId) => {
        const {users} = this.props;
        if(users) {
            let userName = users.ResultList.find(u => u.Id === userId);
            if(userName){
                return `${userName.FirstName} ${userName.LastName}`
            }else{
                return "Unknown User"; //`Unknown User`;
            }
        }
    };
  
  selectedTab = (key) => {
    this.setState({currentTab: key})
  };
  
  
  render() {
        const { regionalAirlines, regionalAirports, user, classes } = this.props;
        let modifiedAirline = [...regionalAirlines];
        let allAirlines = {Airline: "All Airlines", AirlineId: "-1"};
        modifiedAirline.unshift(allAirlines);

        const { createdByStatuses, createdByStatus, viewModal, selectedAirlineRouteRecord, Comment, approvalStatus, routeFormModal, approvalModal, AirlineId, Status, statuses, totalCounts, pageSize, currentPage, airlinesRoutes } = this.state;
        return (
            <div>
                {/* Route View*/}
                <Modal
                    title={false}
                    content={
                        <AirlineRouteTable
                            activeAirlineRoute={selectedAirlineRouteRecord}
                            filterUsers={this.filterUsers}
                        />
                    }
                    modalStatus={viewModal}
                    handleClose={this.closeViewRouteModal}
                    modalStyle={customModalStyle}
                />


                {/* Route Approval*/}
               <Dialog
                   fullWidth={true}
                   maxWidth={'sm'}
                   open={approvalModal}
                   onClose={()=>{}}
                   aria-labelledby="responsive-dialog-title"
               >
                   <DialogTitle id="responsive-dialog-title" style={{ color: `${appConstants.REGIONAL_COLOR}` }}>
                       <div>
                           <span style={{ color: `${appConstants.REGIONAL_COLOR}`}}> Airline Route</span>
                       </div>
                   </DialogTitle>
                   <DialogContent style={{ marginTop: "20px" }}>
                       {
                           approvalStatus === 1 &&
                           (<div>
                               <h1 style={{margin: 0, textAlign: 'center'}}>
                                   <CheckIcon style={{color: `${appConstants.REGIONAL_COLOR}`, fontSize: '60px'}}/>
                               </h1>
                               <p style={{margin: 0, textAlign: 'center'}}>
                                   Are you sure you want to approve record?
                               </p>
                           </div>)
                       }
                       {
                           approvalStatus === 2 &&
                           (<div>
                               <h1 style={{margin: 0, textAlign: 'center'}}>
                                   <DeclineIcon style={{color: `${appConstants.DANGER_COLOR}`, fontSize: '60px'}}/>
                               </h1>
                               <p style={{margin: 0, textAlign: 'center'}}>
                                   Are you sure you want to decline record?
                               </p>
                           </div>)
                       }

                       <div>
                           <TextField
                               style={{
                                   width:"100%",
                                   minWidth:"300px"
                               }}
                               multiline
                               rowsMax="10"
                               id="Comment"
                               label="Reason"
                               name="Comment"
                               value={Comment}
                               onChange={this.handleSelectChange}
                               margin="normal"
                               variant="outlined"
                           />
                           <div style={{
                               color:"red",
                               fontSize:"12px"
                           }}>*State your reason
                           </div>

                       </div>
                       <div style={{textAlign: 'center'}}>
                           <Button
                               disabled={ Comment === ""}
                               onClick={this.handleApproval} color={'regional'}>
                               Ok, continue
                           </Button>
                           &nbsp;<Button onClick={this.handleDismissApprovalModal} color={'danger'}>
                               Dismiss
                           </Button>
                       </div>
                   </DialogContent>

               </Dialog>

                {/*New Airline Route*/}
               <Dialog
                   fullWidth={true}
                   maxWidth={'md'}
                   open={routeFormModal}
                   onClose={()=>{}}
                   aria-labelledby="responsive-dialog-title"
               >
                   <DialogTitle id="responsive-dialog-title" style={{ color: `${appConstants.REGIONAL_COLOR}` }}>
                       <div style={{float : 'left'}}>
                           <span style={{ color: `${appConstants.REGIONAL_COLOR}`}}> Add Route</span>
                       </div>
                       <div style={{float : 'right'}}>
                          <span onClick={this.handleAddRouteModal}>
                           <DismissIcon style={{ cursor: 'pointer', fontSize: '30px', color: `${appConstants.REGIONAL_COLOR}`}}/>
                          </span>
                       </div>

                   </DialogTitle>
                   <DialogContent style={{ marginTop: "20px" }}>
                        <RouteFormPanel
                            classes={classes}
                            airlines={regionalAirlines}
                            airports={regionalAirports}
                            user={user}
                            handleCreateRoute={this.handleCreateRoute}
                            // IsRegional={IsRegional}
                        />
                   </DialogContent>

               </Dialog>

                {/* Search panel */}
                <SearchComponent
                    airlines={modifiedAirline}
                    statuses={statuses}
                    airports={regionalAirports}
                    selectChange={(e, name) => this.handleReactSelectChange(e, name)}
                    AirlineId={AirlineId}
                    Status={Status}
                    createdByStatus={createdByStatus}
                    createdByStatuses={createdByStatuses}
                    onSearch={this.handleSearch}
                    handleAddRouteModal={this.handleAddRouteModal}
                />

                {/* Records */}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Tabs
                            headerColor="regional"
                            tabs={[
                                {
                                    tabName: "Airlines Routes",
                                     clickEvent: (key) => this.selectedTab(key),
                                    tabContent: (
                                        <AirlineRoutes
                                            classes={classes}
                                        />
                                    )
                                },
                                {
                                    tabName: "Routes Request",
                                  clickEvent: (key) => this.selectedTab(key),
                                  tabContent: (
                                        <RecordsTable
                                            classes={classes}
                                            user={user}
                                            totalCounts={totalCounts}
                                            records={airlinesRoutes}
                                            handleSearch={this.handleSearch}
                                            currentPage={currentPage}
                                            pageSize={pageSize}
                                            handleViewRouteModal={this.handleViewRouteModal}
                                            handleApprovalModal={this.handleApprovalModal}
                                            handleApproval={this.handleApproval}
                                            filterUsers={this.filterUsers}
                                        />
                                    )
                                }
                            ]}
                        />
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}


function mapStateToProps(state, ownProps) {
    const { alert, regionalAirlines, requesting, progress, user, users, regionalAirports} = state;
    return {
        user,
        alert,
        regionalAirlines,
        progress,
        requesting,
        users,
        regionalAirports
    };
}

export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(AirlineRouteComponent)));



// WEBPACK FOOTER //
// ./src/Regional-Views/AirlineRouteSettings/index.js